<script setup>


defineProps({
  employeesWithPendingDays: {
    type: Object,
    required: true
  }
})

</script>

<template>
  <el-row class="mt-4">
    <el-col :span="24">
      <div class="table table-users pt-0 px-4 w-100">
        <table class="table-not-mobile">
          <thead>
            <tr>
              <th>
                <div class="d-flex justify-content-start">
                  <img src="@/assets/icons/user.svg" alt="" width="20" />
                  <span class="ml-1">NOMBRES Y APELLIDOS</span>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-start">
                  <img src="@/assets/icons/hollidays.svg" alt="" width="20" />
                  <span class="mt-1 ml-1">DÍAS x AÑO</span>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-start">
                  <img src="@/assets/icons/hollidays.svg" alt="" width="20" />
                  <span class="mt-1 ml-1">DÍAS CONSUMIDOS</span>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-start">
                  <img src="@/assets/icons/hollidays.svg" alt="" width="20" />
                  <span class="mt-1 ml-1">DÍAS DISPONIBLES</span>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-start">
                  <img src="@/assets/icons/hollidays.svg" alt="" width="20" />
                  <span class="mt-1 ml-1">DÍAS x APROBAR</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="employee in employeesWithPendingDays.employees" :key="employee.id + employee.name">
              <td>
                {{ employee.name }} {{ employee.lastName }}
              </td>
              <td>
                {{ employee.vacationDaysPerYear }}
              </td>
              <td>
                {{ employee.consumedDays }}
              </td>
              <td>
                {{ employee.availableDays }}
              </td>
              <td>
                {{ employee.pendingDaysToApprove }}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="table-mobile">
          <div v-if="employeesWithPendingDays && employeesWithPendingDays.employees?.length > 0">
            <div v-for="employee in employeesWithPendingDays.employees" :key="employee.id + employee.name">
              <el-row class="mt-2">
                <el-card class="card-holiday-item">
                  <div class="row d-flex">
                    <div class="el-col-xs-24">
                      <span class="holiday-item-span-name">
                        {{ employee.name }} {{ employee.lastName }}
                      </span>
                    </div>
                    <div class="el-col-xs-24">
                      <span class="holiday-item-span">Días x Año: </span>{{ employee.vacationDaysPerYear }}
                    </div>
                    <div class="el-col-xs-24">
                      <span class="holiday-item-span">Días Consumidos: </span><b class="consumed">{{ employee.consumedDays }}</b>
                    </div>
                    <div class="el-col-xs-24">
                      <span class="holiday-item-span">Días Disponibles: </span>{{ employee.availableDays }}
                    </div>
                    <div class="el-col-xs-24">
                      <span class="holiday-item-span">Días x Aprobar: </span><b class="pending">{{
                        employee.pendingDaysToApprove }}</b>
                    </div>
                  </div>
                </el-card>
              </el-row>
            </div>
          </div>
          <div v-else>
            <h5>No se han encontrado empleados...</h5>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<style scoped lang="scss">
#islands {
  fill: $bg-blue;
  width: 25px;
}

#calendar-icon {
  fill: $bg-blue;
  height: 25px;
  width: 25px;
}

.card-title {
  letter-spacing: -0.05em;

  font-weight: bolder;
  margin-right: 10px;
  letter-spacing: -0.05em;
  font-size: 1.5em;
  color: $font-blue-color;
}

.table-users {
  table {
    thead {
      tr {
        th {
          padding: 0px !important;
          margin: 0px !important;
        }
      }
    }

    tbody {
      td {
        letter-spacing: -0.05em;

        font-weight: bolder;

        letter-spacing: -0.05em;
        font-size: 0.9em;

        .link-name {
          margin: auto;
          margin-left: 10px;
        }
      }
    }
  }
}


@media(min-width: 768px) {
  .table-mobile {
    display: none;
  }
}

@media(max-width: 767px) {
  .consumed{
    color: #F9156F;
  }
  .pending{
  color: #F7D20E;
  }

  .table-not-mobile {
    display: none;
  }

  .table-users {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }

  .table-mobile {
    .card-holiday-item {
      width: 100%;
      padding: 8px 0px;
      border-radius: 16px;
      font-size: 15px;

      .holiday-item-span,
      .holiday-item-span-name {
        color: $bg-blue;
        font-weight: 800;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: -0.05em;
      }

      .holiday-item-span-name {
        font-size: 18px;
      }
    }
  }
}
</style>
